import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import moment from 'moment';
import { DISPLAY_DATE_FORMAT2 } from '../../constants';
import { getDateRange, parseToMoment } from '../../helpers/common';

const RangeBoxDate = () => {
    const { range, customRange, custom } = useSelector(state => state.analyze.searchParams);
    const timezoneIdentifier = useSelector(state => state.farm.currentFarm.timezone_identifier);
    const [isSingleDate, setSingleDate] = useState(false);
    const [dateWidth, setDateWidth] = useState();

    useEffect(() => {
        const timeFormat = DISPLAY_DATE_FORMAT2;
        const fromDate = moment(custom.from).format(timeFormat);
        const toDate = moment(custom.to).format(timeFormat);

        fromDate === toDate ? setSingleDate(true) : setSingleDate(false);
    }, [custom]);

    useEffect(() => {
        (customRange === "absolute" || customRange === "today" || customRange === "yesterday") ? setDateWidth("200px") : setDateWidth("260px");
        if (customRange === "planned" || customRange === "todate") setDateWidth("80px");
    }, [customRange]);

    const getDisplayName = () => {
        let { name, range: selectedDateRange } = getDateRange({ range, customRange, custom, isQuickToggle: true });

        const timeFormat = DISPLAY_DATE_FORMAT2;
        /* const now = moment.utc().tz(timezoneIdentifier).format(timeFormat);
        const fromDate = moment(custom.from).format(timeFormat);
        const toDate = moment(custom.to).format(timeFormat);

        const date = moment.utc().tz(timezoneIdentifier).format(timeFormat);
        const yesterdayDate = moment(date).subtract(1).format(timeFormat); */

        const customFrom = parseToMoment(custom.from);
        const customTo = parseToMoment(custom.to);
        const now = moment.utc().tz(timezoneIdentifier);
        const fromDate = customFrom ? customFrom.tz(timezoneIdentifier).format(timeFormat) : null;
        const toDate = customTo ? customTo.tz(timezoneIdentifier).format(timeFormat) : null;
        const yesterdayDate = now.clone().subtract(1, 'days').format(timeFormat);

        if (fromDate === now && fromDate === toDate && customRange === "absolute") name = "Today";

        if (fromDate === yesterdayDate && fromDate === toDate && customRange === "absolute") name = "Yesterday";

        if (name && !selectedDateRange) return name;

        return (<>
            {name && name !== "Absolute" ?
                <span>
                    <i className="fa fa-clock-o" aria-hidden="true" /> {name} <span className="mr-2">-</span>
                </span>
                :
                (isSingleDate ?
                    <span className="mr-3">
                        <i className="fa fa-clock-o" aria-hidden="true" /> &nbsp;{(moment(selectedDateRange, "DD MMM YYYY").format('dddd'))} &nbsp; -
                    </span> : null)}

            {selectedDateRange && fromDate === toDate ? <><i className="fa fa-calendar" /> {moment(selectedDateRange, "DD MMM").format("DD MMM")}</> : <><i className="fa fa-calendar" /> {isSingleDate ? moment(selectedDateRange, "DD MMM").format("DD MMM") : selectedDateRange}</>}</>
        );
    }

    return (
        <div className="Date-Range" style={{ height: "0px", width: dateWidth }}>
            <span className="ml-1">{getDisplayName()}</span>
        </div>
    )
}

export default RangeBoxDate;

